import { configureStore } from "@reduxjs/toolkit";
import threadsReducer from "./slices/threadsSlice"
import dataSourcesReducer from "./slices/dataSourcesSlice"
import criticalitemsReducer from './slices/criticalItemsSlice'
import bookmarksReducer from './slices/bookmarksSlice'
import feedbackReducer from './slices/feedbackSlice'
import kpiReportingReducer from './slices/kpiReportingSlice'
import kpiTrendsReducer from './slices/kpiTrendsSlice'
import emergingAlertsReducer from './slices/emergingAlertsSlice'

export const store = configureStore({
    reducer: {
        allThreads: threadsReducer,
        dataSources: dataSourcesReducer,
        criticalItems: criticalitemsReducer,
        bookmarks: bookmarksReducer,
        feedbacks: feedbackReducer,
        kpi_report: kpiReportingReducer,
        kpi_trends: kpiTrendsReducer,
        emerging_alerts: emergingAlertsReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch